import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Notification } from "@/models"
import { rest } from "lodash";

const getAllNotifications = (context, params) => restApiDispatcher(context, {
    resource: Notification,
    storeKey: "notifications",
    loadingKey: "notificationsLoading",
    action: "index",
    commitType: "indexUnwrapped",
    metaKey: "systemNotiMeta",
    params
})

const readNotification = (context, params) => restApiDispatcher(context, {
    resource: Notification,
    storeKey: "notification",
    loadingKey: "notificationsLoading",
    action: "readNotification",
    commitType: "show",
    params
})

const renewalSystemNotification = (context, params) => restApiDispatcher(context, {
    resource: Notification,
    storeKey: "upgradeNotifications",
    loadingKey: "notificationsLoading",
    action: "renewalSystemNotification",
    commitType: "resourceObjectWrappedIndex",
    metaKey: "upgradeNotiMeta",
    params
})

const readNotificationUpgrade = (context, params) => restApiDispatcher(context, {
    resource: Notification,
    storeKey: "notification",
    action: "readNotificationUpgrade",
    commitType: "show",
    params
})

const readLocalNotifications = (context, params) => context.commit('NOTIFICATION_READ', params)

const updateNotificationList = (context, params) => context.commit('UPDATE_NOTIFICATION_LIST', params)

const readLocalNotificationsUpgrade = (context, params) => context.commit('UPDATE_NOTIFICATION_LIST_UPGRADE', params)


export default {
    getAllNotifications,
    updateNotificationList,
    readNotification,
    readLocalNotifications,
    renewalSystemNotification,
    readLocalNotificationsUpgrade,
    readNotificationUpgrade
}